import { useState, useEffect } from 'react';
import io from 'socket.io-client';
import Toast from '../components/Shared/Toast/Toast';
import CommonConfig from './constant';
import { useNavigate } from 'react-router-dom';

const socketUrl = process.env.REACT_APP_API_ENDPOINT;

const useSocket = (onNewBuildFound) => {
  const [socket, setSocket] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const currentUser = CommonConfig.loginData('ERPLoginData');
    const userId = currentUser?._id;

    if (!userId || !socketUrl) return;

    const newSocket = io(socketUrl, {
      transports: ['websocket', 'polling'],
      auth: { userId },
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    });

    setSocket(newSocket);

    newSocket.on('connect', () => console.log('✅ Socket connected'));
    newSocket.on('connect_error', (error) => console.error('❌ Socket error:', error));
    newSocket.on('disconnect', (reason) => console.warn('⚠️ Socket disconnected:', reason));

    newSocket.on('logout', async (data) => {
      Toast.info({ message: data.message });
      try {
        await CommonConfig.handleLogout(currentUser?._id, navigate);
      } catch (error) {
        console.error('🚫 Logout failed:', error);
      }
    });

    newSocket.on('newFeatureReleased', (data) => {
      console.log('📩 New feature released:', data);
      if (onNewBuildFound) onNewBuildFound();
    });

    return () => {
      newSocket.removeAllListeners();
      newSocket.off('logout');
      newSocket.disconnect();
      console.log('🧹 Socket cleanup done');
    };
  }, [navigate]);

  return socket;
};

export default useSocket;
